import { expandTransactionParts } from "./financeSplits";

export const UNCATEGORIZED_ID = "__uncategorized__";

export function categoryIdsInPeriod(transactions = []) {
  const ids = new Set();
  (transactions || []).flatMap(expandTransactionParts).forEach((part) => {
    if (!part.category_uuid) {
      ids.add(UNCATEGORIZED_ID);
      return;
    }
    ids.add(String(part.category_uuid));
    if (part.parent_category_uuid) ids.add(String(part.parent_category_uuid));
  });
  return ids;
}

export function categoryFilterOptions(categories = [], presentIds = null) {
  const list = [];
  (categories || [])
    .filter((cat) => !cat.system_key)
    .forEach((cat) => {
      const parentId = String(cat.category_uuid);
      const children = (cat.children || []).filter(
        (child) => !presentIds || presentIds.has(String(child.category_uuid))
      );
      if (presentIds && !presentIds.has(parentId) && !children.length) return;
      list.push({
        id: parentId,
        label: cat.name,
        indent: false,
      });
      children.forEach((child) => {
        list.push({
          id: String(child.category_uuid),
          label: `${cat.name} / ${child.name}`,
          indent: true,
        });
      });
    });
  if (!presentIds || presentIds.has(UNCATEGORIZED_ID)) {
    list.push({ id: UNCATEGORIZED_ID, label: "Ukategoriseret", indent: false });
  }
  return list;
}

export function partMatchesCategoryFilter(part, selectedIds) {
  if (!selectedIds || !selectedIds.length) return true;
  const selected = new Set(selectedIds.map(String));
  if (!part.category_uuid) return selected.has(UNCATEGORIZED_ID);
  const self = String(part.category_uuid);
  const parent = String(part.parent_category_uuid || part.category_uuid);
  return selected.has(self) || selected.has(parent);
}

export function transactionMatchesCategoryFilter(tx, selectedIds) {
  if (!selectedIds || !selectedIds.length) return true;
  return expandTransactionParts(tx).some((part) => partMatchesCategoryFilter(part, selectedIds));
}

export function countsTowardOverview(part, household) {
  if (household && part.is_internal_transfer) return false;
  if (!household && part.exempt_from_budget) return false;
  return true;
}

export function totalsFromTransactions(transactions, selectedIds, household) {
  let income = 0;
  let expenses = 0;
  (transactions || []).flatMap(expandTransactionParts).forEach((part) => {
    if (!countsTowardOverview(part, household)) return;
    if (!partMatchesCategoryFilter(part, selectedIds)) return;
    const amount = Number(part.amount || 0);
    if (amount > 0) income += amount;
    else expenses += Math.abs(amount);
  });
  return { income, expenses, net: income - expenses };
}
